module.exports = __webpack_public_path__ + "img/025-shopping-bag.0f293bb5.svg";